'use client';

import { FunctionComponent } from 'react';
import styles from './styles.module.scss';
import ButtonLink from '../../../../../../../components/ButtonLink';
import { getBookingUrl } from '../../../../../../../services/getBookingUrl';
import { PublicCourse, PublicEducator } from '@cademy-package/sdk-component-types';
import { useMinisiteLink } from '../../../../../../../hooks/useMinisiteLink';

export type ActionsProps = {
    courseSlug: PublicCourse['slug'];
    courseType: PublicCourse['type'];
    educatorSlug: PublicEducator['slug'];
    occurrenceId?: string;
    futureDates?: boolean;
};

export const Actions: FunctionComponent<ActionsProps> = ({
    courseSlug,
    educatorSlug,
    courseType,
    occurrenceId,
    futureDates,
}) => {
    const courseLink = useMinisiteLink(educatorSlug, courseSlug);
    const bookLink = getBookingUrl({
        courseSlug,
        courseType,
        educatorSlug,
        isEmbed: true,
        occurrenceId,
    });
    const label = courseType === 'on-demand' ? 'Enroll' : 'Book';

    if (futureDates) {
        return (
            <div className={styles.actions}>
                <ButtonLink
                    className={styles.button}
                    href={bookLink}
                    target="_blank"
                    preset="primary"
                >
                    {label}
                </ButtonLink>
                <ButtonLink
                    className={styles.button}
                    href={courseLink}
                    preset="default"
                    target="_blank"
                >
                    View
                </ButtonLink>
            </div>
        );
    }

    return (
        <div className={styles.actions}>
            <ButtonLink
                className={styles.button}
                href={courseLink}
                preset="default"
                target="_blank"
            >
                View
            </ButtonLink>
        </div>
    );
};
